import dayjs from 'dayjs';
import { DataModel } from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { SeatInfo } from './seat-info.js';

/**
 * Use {@link EventSeatingStateHelper} to mutate instances of this class.
 */
export abstract class SeatingStateBase extends DataModel {
  abstract get seats(): SeatInfo[];
  abstract get businessRef(): BusinessModuleRef;
  abstract get creationDate(): dayjs.Dayjs;

  get seatCount(): number {
    return this.seats.length;
  }
}
